import React, { useMemo } from 'react'
import { Skeleton } from '../../../components/Skeleton'
import { useInboxMembersCountQuery } from '../../../requests/inboxMembers'

type Props = {
  inboxId: string
}

export const InboxMembersCount: React.FC<Props> = ({ inboxId }) => {
  const { data: count = 0, isLoading: loading } = useInboxMembersCountQuery(inboxId)

  const text = useMemo(() => {
    if (count === 1) {
      return '1 Member'
    }

    return `${count} Members`
  }, [count])

  if (loading) {
    return <Skeleton width={25} />
  }

  return <>{text}</>
}
